<template>
  <div class="product-links-inputs">
    <div class="d-flex flex-column ">
      <span class="text-neutral-500 mt-5"> {{ label }} </span>
      <div class="d-flex w-100 gap-3">
        <bp-input
          class="flex-fill"
          :value="url"
          id="link-sales-page"
          disabled
          size="xl"
        />
        <bp-button icon="fa-light fa-copy" size="xl" @click="copy" />
        <bp-button
          icon="fa-light fa-arrow-up-right-from-square"
          size="xl"
          @click="open"
        />
      </div>
    </div>
  </div>
</template>

<script>
import copy from "copy-text-to-clipboard";

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    plan_offer: {
      type: Object,
      default: null
    },
    group: {
      type: [Number, String, Object],
      default: ""
    },
    label: {
      type: String,
      default: "Checkout"
    },
    custom_url: {
      type: String,
      default: null
    }
  },
  computed: {
    url() {
      if (this.custom_url) return this.custom_url;

      if (this.plan_offer) {
        if (this.group) {
          return this.plan_offer.url + "&group=" + this.group.id;
        }
        return this.plan_offer.url;
      }
      return this.product.url;
    }
  },
  methods: {
    copy() {
      copy(this.url);
      this.$message.success("Link copiado");
    },
    open() {
      window.open(this.url, "_blank");
    },
    toShort() {}
  }
};
</script>
<style lang="scss" scoped>
.bp-button-xl {
  padding: 12px !important;
}
</style>
